var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { CLOSE_REASONS } from "../lib/constants";
import { NAIVAGATE_BACK_TRIGGERED_BY_TYPES } from "../lib/TrellisAnalytics";
import { PHASE } from "../routeConfig";
import { POST_MESSAGE_TYPES } from "../constants";
import { navigatedBack } from "../lib/Avo";
import useAppDispatch from "./useAppDispatch";
import useAppSelector from "./useAppSelector";
import useCloseClickHandler from "./useCloseClickHandler";
import { useLocation } from "react-router-dom";
import useMemoryHistory from "./useMemoryHistory";
export default function useTrellisWindowEventListener() {
    var handleCloseClick = useCloseClickHandler();
    var _a = useMemoryHistory(), push = _a.push, goBack = _a.goBack, entries = _a.entries;
    var location = useLocation();
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var dispatch = useAppDispatch();
    var initialRoute = entries[0];
    React.useEffect(function () {
        var handleTrellisMessage = function (event) {
            switch (event.data.name) {
                case POST_MESSAGE_TYPES.CLICKED_BACK_BUTTON:
                    handleCloseClick({ reason: CLOSE_REASONS.CLICKED_BROWSER_BACK });
                    break;
                case POST_MESSAGE_TYPES.FORCED_EXIT:
                    handleCloseClick({
                        reason: CLOSE_REASONS.TRIGGERED_FORCED_EXIT_METHOD,
                    });
                    break;
                case POST_MESSAGE_TYPES.EXIT:
                    handleCloseClick({ reason: CLOSE_REASONS.TRIGGERED_EXIT_METHOD });
                    break;
            }
        };
        window.addEventListener("message", handleTrellisMessage);
        return function () {
            window.removeEventListener("message", handleTrellisMessage);
        };
    }, [handleCloseClick]);
    React.useEffect(function () {
        var handleTrellisMessage = function (event) {
            var _a;
            switch (event.data.name) {
                case POST_MESSAGE_TYPES.RESET_STATE:
                    if (initialRoute) {
                        push(initialRoute);
                    }
                    break;
                case POST_MESSAGE_TYPES.CHANGE_PHASE: {
                    var nextRoute = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.phase;
                    if (!nextRoute) {
                        return;
                    }
                    push(nextRoute);
                    break;
                }
            }
        };
        window.addEventListener("message", handleTrellisMessage);
        return function () {
            window.removeEventListener("message", handleTrellisMessage);
        };
    }, [push, initialRoute]);
    React.useEffect(function () {
        var handleTrellisMessage = function (event) {
            switch (event.data.name) {
                case POST_MESSAGE_TYPES.NAVIGATE_BACK: {
                    navigatedBack(__assign(__assign({}, commonAnalyticsProperties), { triggeredBy: NAIVAGATE_BACK_TRIGGERED_BY_TYPES.PROGRAMMATIC_METHOD }));
                    if (location.pathname !== PHASE.SELECT_AUTO_ISSUER) {
                        goBack();
                    }
                    break;
                }
            }
        };
        window.addEventListener("message", handleTrellisMessage);
        return function () {
            window.removeEventListener("message", handleTrellisMessage);
        };
    }, [dispatch, goBack, location.pathname, commonAnalyticsProperties]);
}
